if (!customElements.get('oso-pairing')) customElements.define('oso-pairing', class extends HTMLElement {
  connectedCallback() {
    if (this.events) return;
    this.events = new AbortController();
    this.catalogGeneration = (this.catalogGeneration || 0) + 1;
    this.words = JSON.parse(this.querySelector('[data-osito-strings]').textContent);
    this.rules = JSON.parse(this.querySelector('[data-recommendation-strings]').textContent);
    this.engine = globalThis.OsitoPairing;
    this.products = []; this.catalog = []; this.hasLoaded = false; this.slots = Array(4).fill(null);
    this.volumes = Array(4).fill(.7); this.muted = Array(4).fill(false); this.family = 'bowls'; this.facets = {}; this.limit = 12;
    this.mode = 'shop'; this.anchor = null; this.latest = { tracks: [] };
    this.player = new globalThis.OsoPairingPlayer({ owner: this, onChange: state => this.playerState(state) });
    const on = (el, type, fn, options = {}) => el?.addEventListener(type, fn, { ...options, signal: this.events.signal });
    on(this, 'click', e => {
      const b = e.target.closest('button');
      if (!b || !this.contains(b)) return;
      if (b.dataset.mode) this.setMode(b.dataset.mode);
      if (b.dataset.choose) this.setAnchor(this.byId(b.dataset.choose), true);
      if (b.dataset.add) this.addProduct(this.byId(b.dataset.add));
      if (b.dataset.preview) this.preview(this.byId(b.dataset.preview));
      if (b.hasAttribute('data-add-slot')) { this.slots.push(null); this.volumes.push(.7); this.muted.push(false); this.renderSlots(); }
      if (b.hasAttribute('data-mute')) {
        const i = Number(b.dataset.mute); this.muted[i] = !this.muted[i]; this.player.mute(String(i), this.muted[i]); this.muteState(b, i);
      }
      if (b.hasAttribute('data-remove')) {
        const i = Number(b.dataset.remove); this.setSlot(i, null);
        this.querySelector('[data-slot="' + i + '"]')?.focus({ preventScroll: true });
      }
      if (b.hasAttribute('data-play')) this.playTogether();
      if (b.hasAttribute('data-play-one')) this.toggle(Number(b.dataset.playOne));
      if (b.hasAttribute('data-pause-all')) this.player.pauseAll();
      if (b.hasAttribute('data-stop')) this.player.stopAll();
      if (b.hasAttribute('data-clear')) this.setAnchor(null);
      if (b.hasAttribute('data-more')) { this.limit += 12; this.renderCatalog(false); }
      if (b.hasAttribute('data-retry')) this.load();
      if (b.hasAttribute('data-reset-filters')) {
        this.family = 'bowls'; this.facets = {}; this.limit = 12;
        this.querySelector('[data-family-select]').value = 'bowls';
        this.querySelector('[data-search]').value = ''; this.renderCatalog();
      }
    });
    on(this, 'change', e => {
      if (e.target.hasAttribute('data-family-select')) {
        this.family = e.target.value; this.facets = {}; this.limit = 12; this.renderCatalog();
      }
      if (e.target.hasAttribute('data-facet')) { this.facets[e.target.dataset.facet] = e.target.value; this.limit = 12; this.renderCatalog(); }
    });
    on(this.querySelector('[data-search]'), 'input', () => { this.limit = 12; if (!this.loading) this.renderCatalog(); });
    on(this.querySelector('[data-own]'), 'submit', e => {
      e.preventDefault(); const fields = new FormData(e.currentTarget);
      this.setAnchor({ id: 'own', title: fields.get('name') || this.t('own'),
        type: ({ bowls: 'Bowl', gongs: 'Gong', handpans: 'Handpan' })[fields.get('family')] || 'Bowl',
        note: fields.get('note'), rootNote: fields.get('note'), rootVerified: true,
        cents: fields.get('cents'), rootCents: fields.get('cents'), octave: fields.get('octave') }, true);
    });
    on(this, 'input', e => {
      if (!e.target.hasAttribute('data-volume')) return;
      const i = Number(e.target.dataset.volume); this.volumes[i] = Number(e.target.value) / 100; e.target.style.setProperty('--fill', e.target.value + '%');
      this.player.volume(String(i), this.volumes[i]);
    });
    on(this, 'dragstart', e => {
      const card = e.target.closest('[data-instrument]');
      if (!card || !e.dataTransfer) return;
      e.dataTransfer.setData('text/plain', card.dataset.instrument);
      e.dataTransfer.effectAllowed = 'copy'; card.classList.add('is-dragging');
    });
    on(this, 'dragover', e => {
      const slot = e.target.closest('[data-slot]');
      if (!slot || !e.dataTransfer) return;
      e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; slot.classList.add('is-over');
    });
    on(this, 'dragleave', e => { const slot = e.target.closest('[data-slot]'); if (slot && !slot.contains(e.relatedTarget)) slot.classList.remove('is-over'); });
    on(this, 'drop', e => {
      const slot = e.target.closest('[data-slot]');
      if (!slot || !e.dataTransfer) return;
      e.preventDefault(); slot.classList.remove('is-over');
      const product = this.byId(e.dataTransfer.getData('text/plain'));
      if (product) this.setSlot(Number(slot.dataset.slot), product);
    });
    on(this, 'dragend', () => this.querySelectorAll('.is-over,.is-dragging').forEach(el => el.classList.remove('is-over', 'is-dragging')));
    on(document, 'oso:audio-start', e => { if (e.detail?.owner !== this) this.player.pauseAll(); });
    on(document, 'play', e => {
      if (e.target instanceof HTMLMediaElement && !this.contains(e.target) && !this.player.ownsMedia(e.target)) this.player.pauseAll();
    }, { capture: true });
    this.querySelector('[data-family-select]').value = 'bowls';
    this.renderSlots(); this.load();
  }
  t(key) { return this.words[key] || key; }
  node(tag, className, text) { const n = document.createElement(tag); if (className) n.className = className; if (text !== undefined) n.textContent = text; return n; }
  button(key, data) { const b = this.node('button', '', this.t(key)); b.type = 'button'; Object.assign(b.dataset, data); return b; }
  byId(id) { return this.catalog.find(p => String(p.id) === String(id)); }
  playable(p) { return !!globalThis.OsoPairingPlayer.source(p); }
  async load() {
    if (this.loading) return;
    this.loading = true; const generation = this.catalogGeneration;
    const status = this.querySelector('[data-catalog-status]');
    status.textContent = this.t('loading'); this.querySelector('[data-retry]').hidden = true;
    try {
      const products = await globalThis.OsoInstrumentCatalog.load(this.dataset.root || '/');
      if (generation !== this.catalogGeneration || !this.events || this.events.signal.aborted) return;
      this.products = products; this.catalog = products.filter(this.engine.pairingInstrument).sort((a, b) => this.engine.pairingPriority(a) - this.engine.pairingPriority(b)); this.hasLoaded = true;
      this.renderCatalog();
      if (!this.linkedBowlHandled) {
        this.linkedBowlHandled = true;
        const bowlId = new URLSearchParams(location.search).get('bowl');
        const bowl = bowlId && /^\d{1,20}$/.test(bowlId) ? this.byId(bowlId) : null;
        if (bowl && !this.anchor && !this.slots.some(Boolean)) this.setAnchor(bowl);
      }
      if (this.anchor) this.renderMatches();
    } catch {
      if (generation === this.catalogGeneration && this.events && !this.events.signal.aborted) {
        status.textContent = this.t('load_error'); this.querySelector('[data-retry]').hidden = false;
      }
    } finally { if (generation === this.catalogGeneration) this.loading = false; }
  }
  setMode(mode) {
    this.mode = mode; this.querySelector('[data-own]').hidden = mode !== 'own';
    this.querySelectorAll('[data-mode]').forEach(x => x.setAttribute('aria-pressed', String(x.dataset.mode === mode)));
    this.setAnchor(null);
  }
  spec(p) {
    const note = this.engine.one(p.note), cents = this.engine.number(p.cents), octave = this.engine.one(p.octave);
    return [note ? this.t('note') + ' ' + note : '', cents !== null ? this.t('cents') + ' ' + (cents > 0 ? '+' : '') + cents : '', octave ? this.t('octave') + ' ' + octave : ''].filter(Boolean).join(' · ');
  }
  card(p, match) {
    const card = this.node('article', 'osito__card'); card.draggable = true; card.dataset.instrument = p.id;
    if (p.image) {
      const a = this.node('a', 'osito__image'); a.href = p.url; a.draggable = false; a.setAttribute('aria-label', this.engine.clean(p.title));
      const img = this.node('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy'; img.draggable = false; a.append(img); card.append(a);
    }
    const content = this.node('div', 'osito__card-content'), title = this.node('h3');
    const link = this.node('a', '', this.engine.clean(p.title)); link.href = p.url; link.draggable = false; title.append(link);
    link.title = this.engine.clean(p.title);
    const meta = this.node('div', 'osito__card-meta'), spec = this.spec(p);
    if (spec) meta.append(this.node('span', 'osito__spec', spec));
    if (p.price) meta.append(this.node('span', 'osito__price', p.price));
    if (!this.playable(p)) meta.append(this.node('span', 'osito__audio-label', this.t('no_recording')));
    content.append(title, meta);
    if (match) content.append(this.node('p', 'osito__reason', (this.rules[match.kind] || '') + (match.group === 'harmonic' && match.delta !== null ? ' · ' + this.rules.cents_match : '')));
    const actions = this.node('div', 'osito__card-actions');
    const add = this.button('add', { add: String(p.id) });
    add.setAttribute('aria-label', this.t('add') + ': ' + this.engine.clean(p.title));
    actions.append(add); card.append(content, actions); return card;
  }
  renderCatalog(resetScroll = true) {
    if (this.loading && !this.hasLoaded) return;
    const options = { family: this.family, query: this.querySelector('[data-search]').value.trim(), facets: this.facets };
    const products = this.engine.filter(this.catalog, options);
    this.renderFacets(options);
    this.querySelector('[data-results]').replaceChildren(...products.slice(0, this.limit).map(p => this.card(p)));
    this.querySelector('[data-catalog-status]').textContent = products.length ? Math.min(this.limit, products.length) + ' ' + this.t('of') + ' ' + products.length : this.t('empty');
    this.querySelector('[data-more]').hidden = products.length <= this.limit; this.updateButtons();
    if (resetScroll) this.querySelector('.osito__catalog-scroll').scrollTop = 0;
  }
  renderFacets(options) {
    this.querySelectorAll('[data-facet]').forEach(select => {
      const key = select.dataset.facet; this.querySelector('[data-facet-label="' + key + '"]').hidden = key === 'alchemy' && !['all', 'bowls'].includes(this.family);
      const current = this.facets[key] || '', entries = this.engine.facetOptions(this.catalog, options, key);
      const any = this.node('option', '', this.t('any')); any.value = ''; const nodes = [any];
      if (current && !entries.some(([v]) => v === current)) entries.push([current, 0]);
      entries.forEach(([value, count]) => { const n = this.node('option', '', this.engine.clean(value) + ' · ' + count); n.value = value; nodes.push(n); });
      select.replaceChildren(...nodes); select.value = current;
    });
    const advancedCount = ['cents', 'octave', 'alchemy'].filter(key => this.facets[key]).length;
    const count = this.querySelector('[data-advanced-count]');
    if (count) count.textContent = advancedCount ? ' (' + advancedCount + ')' : '';
  }
  setAnchor(p, reveal = false) {
    this.anchor = p;
    const holder = this.querySelector('[data-anchor]'); holder.replaceChildren();
    if (p) {
      holder.append(this.node('p', 'osito__eyebrow', this.t('anchor')), this.node('h3', '', this.engine.clean(p.title)), this.node('p', 'osito__spec', this.spec(p)), this.button('clear', { clear: '' }));
      if (p.id !== 'own' && !this.slots.some(x => x && String(x.id) === String(p.id))) this.addProduct(p);
    }
    const suggestions = this.querySelector('[data-suggestions]'); suggestions.hidden = !p;
    this.renderMatches(); this.inquiry();
    if (p && reveal) { suggestions.open = true; suggestions.querySelector('summary')?.scrollIntoView({ block: 'nearest' }); }
  }
  accessoryCard(match) {
    const p = match.product, card = this.node('article', 'osito__accessory');
    if (p.image) { const a = this.node('a'); a.href = p.url; a.setAttribute('aria-label', this.engine.clean(p.title)); const img = this.node('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy'; a.append(img); card.append(a); }
    const body = this.node('div'), heading = this.node('h3'), a = this.node('a', '', this.engine.clean(p.title)); a.href = p.url; heading.append(a);
    body.append(heading, this.node('p', '', p.price), this.node('p', 'osito__reason', this.rules[match.kind] || '')); card.append(body); return card;
  }
  renderMatches() {
    const holder = this.querySelector('[data-matches]'), accessories = this.querySelector('[data-accessory-matches]'), section = this.querySelector('[data-accessory-suggestions]');
    holder.replaceChildren(); accessories.replaceChildren(); section.hidden = true;
    if (!this.anchor) return;
    const candidates = this.products.filter(p => !this.engine.instrument(p) || this.engine.pairingInstrument(p));
    const matches = this.engine.recommendations(this.anchor, candidates, { limit: 6, accessories: true, selection: this.slots.filter(Boolean) });
    const instruments = matches.filter(m => m.group !== 'accessory'), tools = matches.filter(m => m.group === 'accessory');
    if (instruments.length) holder.append(...instruments.map(m => this.card(m.product, m)));
    else holder.append(this.node('p', 'osito__no-match', this.t('no_match')));
    if (tools.length) { accessories.append(...tools.map(m => this.accessoryCard(m))); section.hidden = false; }
    this.updateButtons();
  }
  selectedIndices() { return this.slots.flatMap((p, i) => p ? [i] : []); }
  addProduct(p) {
    if (!p || !this.engine.pairingInstrument(p)) return -1;
    const existing = this.slots.findIndex(x => x && String(x.id) === String(p.id));
    if (existing >= 0) return existing;
    let i = this.slots.indexOf(null);
    if (i < 0) { i = this.slots.length; this.slots.push(null); this.volumes.push(.7); this.muted.push(false); }
    this.setSlot(i, p); return i;
  }
  setSlot(i, p) {
    if (!Number.isInteger(i) || i < 0 || i >= this.slots.length || p && !this.engine.pairingInstrument(p)) return;
    if (p && this.slots.some((x, j) => j !== i && x && String(x.id) === String(p.id))) {
      this.querySelector('[data-player-status]').textContent = this.t('duplicate'); return;
    }
    if (String(this.slots[i]?.id || '') === String(p?.id || '')) return;
    this.player.remove(String(i)); this.slots[i] = p; this.muted[i] = false; this.renderSlots();
    if (this.anchor?.id !== 'own' && (!this.anchor || !this.slots.some(x => x && String(x.id) === String(this.anchor.id)))) {
      this.setAnchor(this.slots.find(Boolean) || null);
    } else {
      if (this.anchor) this.renderMatches(); this.inquiry();
    }
  }
  renderSlots() {
    const slots = this.querySelector('[data-slots]');
    this.slots.forEach((p, i) => {
      let holder = slots.querySelector('[data-slot="' + i + '"]');
      if (!holder) { holder = this.node('div', 'osito__slot'); holder.dataset.slot = i; holder.tabIndex = -1; slots.append(holder); }
      const productId = p ? String(p.id) : '';
      if (holder.dataset.rendered === productId) return;
      holder.dataset.rendered = productId;
      const letter = String(i + 1), visual = this.node('div', 'osito__slot-visual');
      visual.append(this.node('span', 'osito__slot-letter', letter)); holder.replaceChildren(visual);
      holder.classList.toggle('is-filled', !!p); holder.setAttribute('aria-label', letter + ': ' + (p ? this.engine.clean(p.title) : this.t('slot_empty')));
      if (!p) { visual.append(this.node('p', '', this.t('slot_empty'))); return; }
      if (p.image) { const img = this.node('img'); img.src = p.image; img.alt = ''; visual.append(img); }
      const details = this.node('div', 'osito__slot-details'), heading = this.node('h3'), link = this.node('a', '', this.engine.clean(p.title)); link.href = p.url; link.title = this.engine.clean(p.title); heading.append(link);
      const status = this.node('p', 'osito__fine', this.t(this.playable(p) ? 'ready' : 'no_recording')); status.dataset.trackStatus = i;
      details.append(heading, status);
      const controls = this.node('div', 'osito__slot-actions'), listen = this.button('play_one', { playOne: String(i) }), remove = this.button('remove', { remove: String(i) });
      listen.disabled = !this.playable(p); remove.setAttribute('aria-label', this.t('remove') + ' ' + this.engine.clean(p.title));
      controls.append(listen, remove);
      const youtube = !p.audio && p.sound?.kind === 'youtube';
      let label;
      if (youtube && globalThis.OsoPairingPlayer.volumeLocked) {
        label = this.node('div', 'osito__volume osito__volume--device');
        const mute = this.button('mute', { mute: String(i) }); mute.disabled = !this.playable(p); this.muteState(mute, i);
        label.append(mute, this.node('span', 'osito__volume-note', this.t('device_volume')));
      } else {
        label = this.node('label', 'osito__volume');
        label.append(this.node('span', 'osito__volume-label', this.t('volume') + ' ' + letter));
        const input = this.node('input');
        input.type = 'range'; input.min = '0'; input.max = '100'; input.value = String(this.volumes[i] * 100); input.dataset.volume = i; input.disabled = !this.playable(p);
        input.style.setProperty('--fill', input.value + '%');
        label.append(input);
      }
      holder.append(details);
      const host = this.node('div', youtube ? 'osito__slot-media' : 'osito__slot-audio'); host.dataset.playerHost = i; holder.append(host);
      const slotControls = this.node('div', 'osito__slot-controls'); slotControls.append(controls, label); holder.append(slotControls);
      this.player.setTrack(String(i), p, host); this.player.volume(String(i), this.volumes[i]); this.player.mute(String(i), this.muted[i]);
    });
    this.updateButtons(); this.playerState(this.player.snapshot()); this.checkPair();
  }
  muteState(b, i) {
    b.textContent = this.t(this.muted[i] ? 'unmute' : 'mute'); b.setAttribute('aria-label', this.t(this.muted[i] ? 'unmute' : 'mute') + ' ' + (i + 1));
  }
  updateButtons() {
    this.querySelectorAll('[data-add]').forEach(b => { const added = this.slots.some(p => p && String(p.id) === b.dataset.add); b.disabled = added; b.textContent = this.t(added ? 'added' : 'add'); });
    this.querySelectorAll('[data-preview]').forEach(b => {
      const i = this.slots.findIndex(p => p && String(p.id) === b.dataset.preview);
      const state = this.latest.tracks.find(t => t.id === String(i))?.state, playing = ['playing', 'buffering'].includes(state);
      const track = this.latest.tracks.find(t => t.id === String(i));
      const p = this.byId(b.dataset.preview);
      b.disabled = !!track && !track.ready && track.state === 'loading';
      b.textContent = this.t(playing ? 'pause' : b.disabled ? 'preparing' : i < 0 && !p?.audio && p?.sound?.kind === 'youtube' ? 'open_player' : 'play_one');
      b.setAttribute('aria-pressed', String(playing));
    });
    const count = this.querySelector('[data-selected-count]'); if (count) count.textContent = ' (' + this.slots.filter(Boolean).length + ')';
  }
  checkPair() { const state = this.engine.groupStatus(this.slots), feedback = this.querySelector('[data-pairing-feedback]'); feedback.hidden = state === 'empty'; feedback.textContent = state === 'empty' ? '' : this.t(state === 'duplicate' ? 'duplicate' : 'pair_' + state); }
  preparePlayback() {
    const preview = customElements.get('oso-product-sound')?.active; preview?.pause();
    document.dispatchEvent(new CustomEvent('oso:audio-start', { detail: { owner: this } }));
    document.querySelectorAll('video,audio').forEach(media => { if (!this.contains(media) && !this.player.ownsMedia(media)) media.pause(); });
  }
  toggle(i) {
    if (!this.playable(this.slots[i])) return;
    const track = this.player.snapshot().tracks.find(t => t.id === String(i));
    if (track && !track.ready && track.state === 'loading') return;
    this.preparePlayback(); this.player.toggle(String(i));
  }
  preview(p) {
    const i = this.addProduct(p); if (i < 0 || !this.playable(p)) return;
    if (!p.audio && p.sound?.kind === 'youtube') this.querySelector('[data-slot="' + i + '"]')?.scrollIntoView({ block: 'nearest' });
    this.toggle(i);
  }
  playTogether() {
    this.preparePlayback();
    this.player.playAll(this.selectedIndices().filter(i => this.playable(this.slots[i])).map(String));
  }
  playerState(snapshot) {
    this.latest = snapshot;
    if (!this.events || !snapshot?.tracks) return;
    const tracks = snapshot.tracks, active = tracks.filter(t => ['playing', 'buffering'].includes(t.state));
    tracks.forEach(track => {
      const p = this.slots[Number(track.id)]; if (!p) return;
      const button = this.querySelector('[data-play-one="' + track.id + '"]'), status = this.querySelector('[data-track-status="' + track.id + '"]');
      const playing = ['playing', 'buffering'].includes(track.state);
      if (button) { button.disabled = track.state === 'unavailable' || !track.ready && track.state === 'loading'; button.textContent = this.t(playing ? 'pause' : button.disabled && track.state === 'loading' ? 'preparing' : 'play_one'); button.setAttribute('aria-pressed', String(playing)); button.setAttribute('aria-label', this.t(playing ? 'pause' : 'play_one') + ' ' + this.engine.clean(p.title)); }
      if (status) status.textContent = this.t(({ playing: 'playing', buffering: 'audio_loading', loading: 'loading_player', blocked: 'play_blocked', error: 'sound_error', unavailable: 'no_recording', offscreen: 'video_visible' })[track.state] || 'ready');
    });
    const selected = this.slots.filter(p => this.playable(p));
    this.querySelector('[data-play]').disabled = !tracks.some(t => t.ready && t.kind !== 'unavailable');
    this.querySelector('[data-play]').textContent = this.t(selected.length === 1 ? 'play_one' : 'play');
    this.querySelector('[data-stop]').disabled = !tracks.some(t => !['ready', 'unavailable'].includes(t.state) || t.currentTime > 0);
    const pause = this.querySelector('[data-pause-all]'); if (pause) pause.disabled = !active.length && !tracks.some(t => t.state === 'loading');
    const status = this.querySelector('[data-player-status]');
    const needsAttention = tracks.some(t => ['error', 'blocked', 'offscreen'].includes(t.state));
    status.textContent = this.t(needsAttention ? 'check_recordings' : tracks.some(t => t.state === 'loading') ? 'loading_player' : active.length ? 'playing' : selected.length ? 'ready_group' : 'need_audio');
    this.updateButtons();
  }
  inquiry() {
    const lines = [];
    if (this.anchor) lines.push(this.t('anchor') + ': ' + this.engine.clean(this.anchor.title) + '; ' + this.spec(this.anchor));
    this.slots.forEach((p, i) => { if (p) lines.push((i + 1) + ': ' + this.engine.clean(p.title) + '; ' + new URL(p.url, location.origin).href); });
    this.querySelector('[data-inquiry-selection]').value = lines.join('\n');
  }
  disconnectedCallback() { this.catalogGeneration++; this.loading = false; this.events?.abort(); this.events = null; this.player?.destroy(); }
});
